var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCad = function SvgCad(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -208,
    y: -1380,
    width: 1344,
    height: 2652,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "40px / Fiat"
  }, /*#__PURE__*/React.createElement("g", {
    id: "40px / Fiat / CAD"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 19.75,
    stroke: "#080808",
    strokeOpacity: 0.08,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 42",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5806 32L20.2903 26.8605C20.2861 26.776 20.3025 26.6917 20.3382 26.6138C20.374 26.5359 20.4282 26.4664 20.4969 26.4104C20.5656 26.3544 20.6471 26.3133 20.7353 26.2902C20.8234 26.2671 20.9161 26.2626 21.0065 26.2769L26.5484 27.1762L25.8 25.2705C25.7696 25.1946 25.7657 25.1119 25.7889 25.034C25.812 24.956 25.861 24.8867 25.929 24.8357L32 20.2978L30.6323 19.7082C30.5399 19.6679 30.4666 19.5979 30.4262 19.5112C30.3858 19.4246 30.3811 19.3273 30.4129 19.2377L31.6129 15.8313L28.1161 16.5161C28.0214 16.5344 27.9227 16.5218 27.8369 16.4805C27.7511 16.4393 27.6833 16.3719 27.6452 16.2898L26.9677 14.8189L24.2387 17.5226C24.1763 17.5833 24.0942 17.6238 24.0048 17.6378C23.9154 17.6519 23.8235 17.6388 23.7428 17.6006C23.6621 17.5624 23.5971 17.501 23.5574 17.4257C23.5176 17.3505 23.5054 17.2653 23.5226 17.1831L24.8387 10.9181L22.729 12.0437C22.6795 12.0705 22.6245 12.0876 22.5675 12.094C22.5105 12.1004 22.4527 12.0959 22.3977 12.0808C22.3427 12.0657 22.2916 12.0404 22.2476 12.0063C22.2036 11.9723 22.1676 11.9303 22.1419 11.8829L20 8L17.8581 11.8829C17.8324 11.9303 17.7964 11.9723 17.7524 12.0063C17.7084 12.0404 17.6573 12.0657 17.6023 12.0808C17.5473 12.0959 17.4894 12.1004 17.4325 12.094C17.3755 12.0876 17.3205 12.0705 17.271 12.0437L15.1613 10.9181L16.4774 17.1831C16.4946 17.2653 16.4823 17.3505 16.4426 17.4257C16.4029 17.501 16.3379 17.5624 16.2572 17.6006C16.1765 17.6388 16.0846 17.6519 15.9952 17.6378C15.9057 17.6238 15.8237 17.5833 15.7613 17.5226L13.0323 14.8189L12.3548 16.2898C12.3167 16.3719 12.2489 16.4393 12.1631 16.4805C12.0773 16.5218 11.9786 16.5344 11.8839 16.5161L8.3871 15.8313L9.5871 19.2377C9.6189 19.3273 9.61416 19.4246 9.57377 19.5112C9.53338 19.5979 9.46012 19.6679 9.36774 19.7082L8 20.2978L14.071 24.8357C14.139 24.8867 14.188 24.956 14.2111 25.034C14.2342 25.1119 14.2304 25.1946 14.2 25.2705L13.4516 27.1762L18.9935 26.2769C19.0839 26.2626 19.1766 26.2671 19.2647 26.2902C19.3529 26.3133 19.4344 26.3544 19.5031 26.4104C19.5718 26.4664 19.626 26.5359 19.6618 26.6138C19.6975 26.6917 19.7139 26.776 19.7097 26.8605L19.4194 32H20.5806Z",
    fill: "#FF0000"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCad);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "CAD.b9f3897f78da823041ba7b4ef86791ba.svg";